import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ErrorBoundaryWrapper from '../../shared/components/error-boundary-wrapper';
import Suspense from '../../shared/components/suspense';
import CallLogs from './components/call-logs';
import VoicemailTemplates from './components/call-logs/components/voicemail-templates';
import Reports from './components/call-logs/components/reports';
import PhoneNumberSettings from './components/phone-numbers/components/phone-number-settings';
import PurchasePhoneNumberForm from './components/phone-numbers/components/purchase-phone-number-form';
import PhoneNumbers from './components/phone-numbers/phone-numbers';
import { IProps } from './dialer-container';

const Dialer: React.FC<IProps> = () => {
  const [hasAnyPhoneNumbers] = useState(false);

  return (
    <ErrorBoundaryWrapper>
      <Suspense>
        <Switch>
          {/* call logs — static routes before :callLogId/:tab (drawer URL sync; id = CallLog.id) */}
          <Route
            exact
            path="/dialer/call-logs/voicemail-templates"
            component={VoicemailTemplates}
          />
          <Route exact path="/dialer/call-logs/reports" component={Reports} />
          <Route
            exact
            path="/dialer/call-logs/:callLogId/:tab"
            component={CallLogs}
          />
          <Route exact path="/dialer/call-logs" component={CallLogs} />

          {/* Phone Numbers View Route */}
          <Route
            exact
            path="/dialer/phone-numbers"
            render={() => <PhoneNumbers />}
          />
          <Route
            exact
            path="/dialer/phone-numbers/purchase"
            component={PurchasePhoneNumberForm}
          />
          <Route
            exact
            path="/dialer/phone-numbers/:id/settings"
            component={PhoneNumberSettings}
          />
          <Redirect exact from="/dialer" to="/dialer/call-logs" />
          <Redirect to="/dialer/call-logs" />
        </Switch>
      </Suspense>
    </ErrorBoundaryWrapper>
  );
};

export default Dialer;
